import { FC, PropsWithChildren, ReactElement, useEffect, useState } from 'react';

export type TDelayedMountProps = {
  ms: number;
  readyState?: DocumentReadyState;
  placeholder?: ReactElement;
};

// delay before mounting something
export const DelayedMount: FC<PropsWithChildren<TDelayedMountProps>> = (props) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const onReadyStateChange = () => {
      if (document.readyState === props.readyState) {
        timeout = setTimeout(() => setIsVisible(true), props.ms);
      }
    };

    let timeout: NodeJS.Timeout | null;
    if (props.readyState) {
      if (document.readyState === props.readyState) {
        onReadyStateChange();
      } else {
        document.addEventListener('readystatechange', onReadyStateChange);
      }
    } else {
      timeout = setTimeout(() => setIsVisible(true), props.ms);
    }

    return () => {
      document.removeEventListener('readystatechange', onReadyStateChange);
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [props.children]);

  if (isVisible) {
    return <>{props.children}</>;
  }

  return <>{props.placeholder}</>;
};

